/* eslint-disable max-len */
import React, { useEffect } from "react";
import { array, bool, func, number, object, string } from "prop-types";
import { LoadMoreStoriesBase } from "@quintype/components";
import { connect } from "react-redux";
import { get } from "lodash";

import { NotFoundPage } from "../not-found";
import Stories2AdWithLoadMore from "../../rows/Stories2AdWithLoadMore";
import TagStorySearch from "../../widgets/TagStorySearch";

import { setMobileFilter, setVerticalMenuBar } from "../../helper/actions";
import { staticTexts } from "../../utils/Translate";
import { fireVirtualPageOnSPA } from "../../utils/utils";
import { useDevice } from "../../utils/react-utils";

import "./tag.m.css";

const NO_OF_STORIES_TO_LOAD = 10;

function TagPageBase({
  data,
  lang,
  sections,
  domainSlug,
  setVerticalMenuBar,
  isVerticalMenubar,
  setMobileFilter,
  isMobileFilter,
}) {
  const { mobile, tab, desktop } = useDevice();
  const { tag, localNewsData, stories, title } = data;
  const { localNewsDivisionSlug, localNewsDistrictSlug, localNewsSubDistrictSlug } = localNewsData || {};

  if (!tag) {
    return <NotFoundPage />;
  }

  if (!stories.length) {
    return <div styleName="no-stories">No stories found !!</div>;
  }

  const imgRegex = /<img[^>]*?>/g;
  const tagDescription = tag.description ? tag.description.replace(tag.description.match(imgRegex), "") : "";
  const storyFields =
    "headline,subheadline,author-name,author-id,authors,last-published-at,hero-image-metadata,hero-image-s3-key,slug,id,story-template,tags,url,cards,alternative,metadata";

  const contentStyleName = `content ${
    localNewsDivisionSlug || tag.slug === "district-news" ? "local-news-content" : ""
  }`;

  const toggleFilterSearch = () => {
    mobile && setVerticalMenuBar(!isVerticalMenubar) && setMobileFilter(!isMobileFilter);
  };

  const getStories = () => {
    const bangladeshSection = sections.find((item) => item.name === "bangladesh");

    const defaultQueryObject = {
      limit: 10,
      sort: "latest-published",
    };

    let params = {};

    if (localNewsDivisionSlug && bangladeshSection) {
      params = {
        ...defaultQueryObject,
        "tag-slugs": tag.slug,
        "section-ids": bangladeshSection.id || "",
      };

      return (
        <LoadMoreStoriesBase
          template={MoreCollectionStories}
          fields={storyFields}
          params={params}
          data={data}
          numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
        />
      );
    } else {
      const sectionIds = sections.filter((item) => item["domain-slug"] === domainSlug).map((item) => item.id);
      params = {
        ...defaultQueryObject,
        "tag-name": tag.name,
        "section-id": sectionIds.join(),
      };

      return (
        <LoadMoreStoriesBase
          template={MoreCollectionStories}
          fields={storyFields}
          params={params}
          api="/api/v1/advanced-search"
          data={data}
          apiResponseTransformer={({ items }) => items}
          numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
        />
      );
    }
  };

  const getTagInfo = () => {
    if (localNewsSubDistrictSlug) {
      return "উপজেলা";
    } else if (localNewsDistrictSlug) {
      return "জেলা";
    } else if (localNewsDivisionSlug) {
      return "বিভাগ";
    }
    return staticTexts(lang).tag;
  };

  useEffect(() => {
    handleReload();
  }, [tag.name]);

  const handleReload = () => {
    if (document.readyState === "complete") {
      fireVirtualPageOnSPA("Topics", "Not Applicable", "", title);
    }
  };

  return (
    <React.Fragment>
      <div styleName={contentStyleName}>
        <div styleName="tag-name">
          {(getTagInfo() === "উপজেলা" || getTagInfo() === "জেলা" || getTagInfo() === "বিভাগ") && (
            <h3 styleName="name">{getTagInfo()}</h3>
          )}
          {mobile && (localNewsDivisionSlug || tag.slug === "district-news") && (
            <div
              styleName={`filter-button ${tag.slug === "district-news" ? "district-filter" : ""}`}
              onClick={toggleFilterSearch}
            >
              {staticTexts(lang).filterText}
            </div>
          )}
        </div>
        {tag ? (
          <React.Fragment>
            <h1 styleName="tag-title">{tag.name}</h1>
            {tagDescription ? (
              <span className="sub-title" dangerouslySetInnerHTML={{ __html: tagDescription }}></span>
            ) : null}
          </React.Fragment>
        ) : null}
      </div>
      <div styleName={localNewsDivisionSlug || tag.slug === "district-news" ? "local-news-content-2" : ""}>
        <div>
          {(localNewsDivisionSlug || tag.slug === "district-news") && (isMobileFilter || tab || desktop) && (
            <TagStorySearch
              className="local-news-tag-search"
              {...localNewsData}
              showHeading={tag.slug !== "district-news"}
              isMobileFilter={isMobileFilter}
              toggleFilterSearch={toggleFilterSearch}
            />
          )}
        </div>

        <div>{getStories()}</div>
      </div>
    </React.Fragment>
  );
}

const MoreCollectionStories = ({ stories, onLoadMore, noMoreStories, loading }) => (
  <Stories2AdWithLoadMore
    list={stories}
    loading={loading}
    onLoadMore={onLoadMore}
    isMoreStories={NO_OF_STORIES_TO_LOAD <= stories.length && !noMoreStories}
  />
);

TagPageBase.propTypes = {
  data: object,
  config: object,
  lang: string,
  setVerticalMenuBar: func,
  isVerticalMenubar: bool,
  setMobileFilter: func,
  isMobileFilter: bool,
  sections: array,
  domainSlug: string,
};

MoreCollectionStories.propTypes = {
  stories: object,
  onLoadMore: func,
  noMoreStories: number,
  loading: bool,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", ""], ""),
  isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false),
  isMobileFilter: get(state, ["filterReducer", "isMobileFilter"], false),
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], null),
});

const mapDispatchToProps = (dispatch) => ({
  setVerticalMenuBar: (flag) => dispatch(setVerticalMenuBar(flag)),
  setMobileFilter: (flag) => dispatch(setMobileFilter(flag)),
});

const TagPage = connect(mapStateToProps, mapDispatchToProps)(TagPageBase);

export { TagPage };
